/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { BehaviorSubject, Observable, throwError, of, Subject } from "rxjs";
import { CollectionViewer } from "@angular/cdk/collections";
import { catchError, takeUntil } from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
import { QueryParams, PageResponse, IgniteDataSource } from "@ignite/ignite-common";
import { Location } from "../models/location";
import { LocationService } from "../services/location-service";
import { IgniteGridUpdateResult } from "@ignite/ui-common";

export class LocationDataSource implements IgniteDataSource<Location> {
  private locationSubject = new BehaviorSubject<Location[]>([]);
  private locationUpdateSubject = new BehaviorSubject<IgniteGridUpdateResult>(null);
  private destroy$ = new Subject<void>();

  pageResponse$ = new BehaviorSubject<PageResponse<any>>(new PageResponse<any>());

  constructor(private locationService: LocationService) {}

  connect(collectionViewer: CollectionViewer): Observable<Location[]> {
    return this.locationSubject.asObservable();
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  disconnect(collectionViewer: CollectionViewer): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.locationSubject.complete();
    this.locationUpdateSubject.complete();
    this.pageResponse$.complete();
  }

  connectUpdates(): Observable<any> {
    return this.locationUpdateSubject.asObservable();
  }

  loadLocations(query: QueryParams) {
    this.locationService
      .getLocations(query)
      .pipe(
        takeUntil(this.destroy$),
        catchError((error: HttpErrorResponse) => {
          if (error.status !== 404) {
            return throwError(error);
          }
          return of(new PageResponse<any>());
        })
      )
      .subscribe((pr) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        this.locationSubject.next(pr.items);
        this.pageResponse$.next(pr);
      });
  }

  clearResults() {
    this.locationSubject.next([]);
  }
}
